// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconLinkArrow: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9">
            <path
                fill="currentColor"
                d="M10.5,4.5 C10.5,4.91484404 10.1853019,5.25 9.7696182,5.25 L2.56678656,5.25 L5.04209954,7.72031236 C5.3356613,8.01328111 5.3356613,8.48789048 5.04209954,8.78085923 C4.89414398,8.92734361 4.70156754,9 4.5089911,9 C4.31641465,9 4.12430765,8.92675781 3.97776185,8.78027344 L0.22017132,5.03027344 C-0.07339044,4.73730469 -0.07339044,4.26269531 0.22017132,3.96972656 L3.97776185,0.219726562 C4.27132361,-0.0732421875 4.74689366,-0.0732421875 5.04045542,0.219726562 C5.33401718,0.512695312 5.33401718,0.987304687 5.04045542,1.28027344 L2.56678656,3.75 L9.7696182,3.75 C10.1853019,3.75 10.5,4.08515632 10.5,4.5 Z"
                opacity=".5"
            />
        </svg>
    );
};

export default React.memo(IconLinkArrow);
